module.exports = __webpack_public_path__ + "static/bg-paloma-0c6e6bc014dc5040d24fd3461acce330.jpg";